import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
    alert: {
        alignItems: 'center',
        padding: '16px 20px',
        borderRadius: '12px',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15), 0 4px 8px rgba(0, 0, 0, 0.1)',
        backdropFilter: 'blur(8px)',
        minWidth: '320px',
        maxWidth: '480px',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        '& .MuiAlert-icon': {
            fontSize: '28px',
            marginRight: '12px',
        },
        '& .MuiAlert-message': {
            fontSize: '15px',
            fontWeight: 500,
            lineHeight: 1.4,
        },
        fontSize: 15,
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 9999,
        animation: '$slideInRight 0.3s ease-out',
        '&.MuiAlert-standardSuccess': {
            backgroundColor: 'rgba(76, 175, 80, 0.95)',
            color: 'white',
            '& .MuiAlert-icon': {
                color: 'white',
            },
        },
        '&.MuiAlert-standardError': {
            backgroundColor: 'rgba(244, 67, 54, 0.95)',
            color: 'white',
            '& .MuiAlert-icon': {
                color: 'white',
            },
        },
        '&.MuiAlert-standardWarning': {
            backgroundColor: 'rgba(255, 152, 0, 0.95)',
            color: 'white',
            '& .MuiAlert-icon': {
                color: 'white',
            },
        },
        '&.MuiAlert-standardInfo': {
            backgroundColor: 'rgba(33, 150, 243, 0.95)',
            color: 'white',
            '& .MuiAlert-icon': {
                color: 'white',
            },
        },
    },
    '@keyframes slideInRight': {
        '0%': {
            transform: 'translateX(100%)',
            opacity: 0,
        },
        '100%': {
            transform: 'translateX(0)',
            opacity: 1,
        },
    },
});
